module.exports = __webpack_public_path__ + "static/media/close.6ed295d3.svg";